import { makeRequest } from 'utils/requestLogger';

export default (liveID) =>
  makeRequest(
    'put',
    `/api/live_discussions/${liveID}/participations/me/toggle-audio`
  );



// WEBPACK FOOTER //
// ./src/app/services/liveDiscussion/toggleOwnAudio.js